module.exports = {
  "Fintech_Payment_modification_JNDB_IyfS": "再次上传",
  "Fintech_Payment_information_igvK_UYAz": "你可以在此处添加受益人，并分别设置比例",
  "Fintech_Payment_deposit_sXgz_qKip": "确认信息并输入你想要存入至{{DiDi_Cuenta}}的金额。",
  "Fintech_Payment_modification_MBsk_LuPn": "现在再次上传？",
  "Fintech_Payment_KYC_gnTH_YXOJ": "城市或地区",
  "Fintech_Payment_KYC_ACoB_YJFy": "验证码错误，请重新输入",
  "Fintech_Payment_KYC_SpcY_yEkL": "街区（选填）",
  "Fintech_Payment_AF_iYUV_RZqQ": "收款人",
  "Fintech_Payment_OTP_pEfV_rJQv": "我没有WhatsApp",
  "Fintech_Payment_information_gLTw_udZk": "受益人名字",
  "Fintech_Payment_Bankstatement_VJGG_mzkf": "交易活动明细",
  "Fintech_Payment_Bankstatement_BQiZ_jAEw": "名词缩写注释",
  "Fintech_Payment_website_ojec_kGmp": "请填写你的信息",
  "Fintech_Payment_out_EwYp_MJFT": "输入CLABE",
  "Fintech_Payment_out_DUKE_nxdr": "添加备注名",
  "Fintech_Payment_out_dMcV_dFtS": "收款银行",
  "Fintech_Payment_information_DIYt_yZyx": "手机号",
  "Fintech_Payment_modification_plkZ_lsUh": "CFDI用途",
  "Fintech_Payment_website_vyuH_wVPZ": "仅可输入西语字符、空格和“-”",
  "Fintech_Payment_out_RDFl_sSQx": "CLABE复制成功",
  "Fintech_Payment_KYC_dKAT_heay": "CURP与性别不匹配，请检查所填信息",
  "Fintech_Payment_Bankstatement_SGNJ_vMFp": "地址：{{Sofipo_address}}",
  "Fintech_Payment_KYC_eGso_jeAS": "确认",
  "Fintech_Payment_website_uwvO_Tgil": "请输入正确的邮箱格式",
  "Fintech_Payment_AF_EsIM_hGCv": "5月",
  "Fintech_Payment_KYC_hVEQ_wtLy": "地址过长，最多200字符",
  "Fintech_Payment_Optimization_NOin_alml": "刷新成功",
  "Fintech_Payment_KYC_gWXw_nbwh": "验证成功",
  "Fintech_Payment_Bankstatement_UMxV_lSvi": "{{JP_Sofiexpress}}的专业客服部门接收查询，索赔或澄清事项，该部门位于{{Sofipo_UNE_address}}，同时也可通过电子邮件{{Sofipo_UNE_email}}或电话{{Sofipo_UNE_telephone_number}}进行联系，另外还可前往其任何分支机构或办事处。如果未能获得满意的答复，您可以向国家金融服务用户保护和维权委员会（{{condusef_URL}}，{{condusef_telephone_number1}}，{{condusef_telephone_number2}}）寻求帮助。",
  "Fintech_Payment_Optimization_tyId_PGmu": "支出",
  "Fintech_Payment_deposit_epmY_qubZ": "通过SPEI存款",
  "Fintech_Payment_AF_VBip_Mdss": "登录失效，请尝试重新登录",
  "Fintech_Payment_AF_MXod_mPID": "余额",
  "Fintech_Payment_out_qfne_lRTR": "转账给CLABE",
  "Fintech_Payment_limits_jyYN_OrOp": "被CNBV监管",
  "Fintech_Payment_information_JlDn_qwie": "受益人{{successor_id}}",
  "Fintech_Payment_Bankstatement_rIXn_CUsc": "付款方",
  "Fintech_Payment_page_OQck_lyCE": "我再考虑一下",
  "Fintech_Payment_limits_daNT_fZSS": "请稍后重试",
  "Fintech_Payment_Bankstatement_caBV_jSuG": "名字：{{client_name}}",
  "Fintech_Payment_website_bEUT_jSda": "你已在等候名单中！当你可以开通你的{{brand_name}}时，我们将通过短信和电子邮件通知你。",
  "Fintech_Payment_information_ZlKa_dtuo": "确定要删除这个受益人吗？",
  "Fintech_Payment_information_bUKL_JKrn": "州，国家",
  "Fintech_Payment_AF_HEgl_AkAn": "6月",
  "Fintech_Payment_Bankstatement_cklR_SqlI": "你正在查看你的银行对账单。报告按月自动生成，支持12个月内的查询，超过12个月的报告需要联系客服进行下载。最新的报告时间为{{last_time}}。",
  "Fintech_Payment_Bankstatement_fSIt_lCnP": "选择周期",
  "Fintech_Payment_display__aCTQ": "加载中",
  "Fintech_Payment_limits_jOLq_KpIA": "你输入的金额已超过最大限额，请修改。",
  "Fintech_Payment_AF_gnPZ_eMwX": "上次登录：{{last_login_time}}",
  "Fintech_Payment_limits_laEJ_ZcnK": "加载失败",
  "Fintech_Payment_website_FUOx_KRLc": "此服务由{{Company_name}}提供",
  "Fintech_Payment_limits_PTcx_pRPt": "您输入的金额必须为整数。",
  "Fintech_Payment_AF_FSRh_XVKV": "立刻充值并使用你的{{brand_name}}账户吧",
  "Fintech_Payment_out_jXPS_kJIE": "收款人复制成功",
  "Fintech_Payment_information_zyZu_choS": "还有{{beneficiary_percent}}的比例可以分配",
  "Fintech_Payment_Bankstatement_Vsvj_rvxs": "收入",
  "Fintech_Payment_KYC_TVHz_LQmK": "女性",
  "Fintech_Payment_deposit_CRGm_UzpX": "复制并分享这些信息用于存款到{{DiDi_Cuenta}}",
  "Fintech_Payment_Bankstatement_kAPb_djfK": "日期",
  "Fintech_Payment_website_JrDT_oghx": "2分钟",
  "Fintech_Payment_information_LxSZ_QfdR": "内部门牌号（选填）",
  "Fintech_Payment_Bankstatement_UDGs_sWUv": "描述",
  "Fintech_Payment_modification_XLGP_PkVO": "打开文件浏览失败",
  "Fintech_Payment_Bankstatement_vcou_ppHK": "下载",
  "Fintech_Payment_out_JVhf_uIrz": "余额通常会在{30秒}内到账，若超过{1小时}还没到账，请联系我们以获得帮助",
  "Fintech_Payment_modification_WpyW_UDnG": "一旦你选择再次上传，最新的税务信息可能就会变动。",
  "Fintech_Payment_deposit_hPpV_qxBY": "确认信息",
  "Fintech_Payment_out_xxZL_QggI": "本次最多可转{{amount}}",
  "Fintech_Payment_Optimization_EtqY_nFMb": "当前收益未达到纳税起征额，无需缴纳税款",
  "Fintech_Payment_KYC_UCNu_RKcO": "邮编",
  "Fintech_Payment_KYC_Lwxq_yulz": "Email格式错误",
  "Fintech_Payment_page_ZyPv_vdFF": "通过二维码邀请",
  "Fintech_Payment_deposit_wGvf_isDi": "输入CLABE",
  "Fintech_Payment_information_SgIA_tmLD": "受益人更新成功",
  "Fintech_Payment_compliance_cKLo_wJIN": "金额超过{{amount_limit}}，请保存收款人后转账",
  "Fintech_Payment_modification_zGjh_jAAr": "正在核对你的文件",
  "Fintech_Payment_KYC_Oilm_lUbJ": "当前网络不畅，请稍后重试",
  "Fintech_Payment_Bankstatement_bjpO_mnaj": "因为{{JP_Sofiexpress}}不会向用户收取任何手续费或其他成本费用，所以最低余额要求为0.",
  "GDriver_MX_No_more_bWUF": "没有更多数据",
  "Fintech_Payment_page_XQQd_oNyh": "暂无邀请",
  "Fintech_Payment_modification_AByR_jggK": "现在不",
  "Fintech_Payment_homepage_aMFD_pFAF": "你已开通{{brand_name}}余额，故{{DiDi}}余额充值服务不可用。期待{{brand_name}}余额为你带来更好的支付体验，感谢你的理解与支持。",
  "Fintech_Payment_Bankstatement_PYtp_iPQw": "期初余额",
  "Fintech_Payment_out_XYAo_yuwB": "CLABE",
  "Fintech_Payment_AF_kABS_zWvf": "9月",
  "Fintech_Payment_Bankstatement_AzQw_luej": "邮箱：{{Sofipo_email}}",
  "Fintech_Payment_page_ocIy_NGRn": "请输入正确的手机号",
  "Fintech_Payment_KYC_OnLo_ZYch": "为保障您的账户安全，请填写您的个人信息",
  "Fintech_Payment_homepage_SFsi_SJXU": "请使用{{brand_name}}余额",
  "Fintech_Payment_KYC_zTko_YFzn": "该CURP已被注册",
  "Fintech_Payment_out_amMV_dDSd": "CLABE",
  "Fintech_Payment_AF_fOga_XwyT": "验证失败，请重试",
  "Fintech_Payment_AF_nmDo_eTLN": "1月",
  "Fintech_Payment_Bankstatement_hnLc_DSHR": "支出",
  "Fintech_Payment_simulado_QWNv_ULIU": "存入金额({{monetary_unit}})",
  "Fintech_Payment_KYC_Xwxu_tMgl": "请填写此信息",
  "Fintech_Payment_information_msbx_XiQZ": "账户ID是什么？",
  "Fintech_Payment_deposit_Mlzl_OiyY": "收款人",
  "Fintech_Payment_Cap_oZyP_BVoJ": "计算规则",
  "Fintech_Payment_interest_VgrE_mFyX": "总计",
  "Fintech_Payment_M2_Network_error_pnLW": "网络错误，请重试",
  "Fintech_Payment_deposit_VPvi_NjxF": "目的地银行",
  "Fintech_Payment_AF_qJnT_LvYT": "查看所有",
  "Fintech_Payment_Bankstatement_cqQj_yfpk": "充值手续费",
  "Fintech_Payment_AF_qSLd_ePln": "交易类型",
  "Fintech_Payment_KYC_OZAY_SMnC": "姓名格式错误，请重新填写",
  "Fintech_Payment_limits_ytGb_sMaw": "你输入的金额不符合规则的范围，请修改。",
  "Fintech_Payment_KYC_vZch_DBhR": "请输入手机验证码",
  "Fintech_Payment_AF_odav_vTWX": "12月",
  "Fintech_Payment_information_zqzM_ASyc": "保留",
  "Fintech_Payment_Ahorro_FTbq_RnIh": "请稍后重试",
  "Fintech_Payment_out_eDqd_heBu": "真实姓名",
  "Fintech_Payment_Bankstatement_BWgn_zVrT": "支出",
  "Fintech_Payment_KYC_Nrcd_vCpz": "验证码过期",
  "Fintech_Payment_Optimization_DsID_ESxl": "刷新中",
  "Fintech_Payment_AF_Trse_OFqS": "你好，{{user_name}}",
  "Fintech_Payment_website_hsGy_KTiW": "提交",
  "Global_Rider_1219_Global_Rider_Adding_Card_Components_Optimization_Try_again_gvWg": "重试",
  "Fintech_Payment_page_lcMk_kyGN": "WhatsApp分享",
  "Fintech_Payment_KYC_UfeV_RamV": "CURP与生日不匹配，请检查所填信息",
  "Fintech_Payment_KYC_hava_mqZj": "男性",
  "Fintech_Payment_Bankstatement_ewnH_wIGD": "咨询与投诉",
  "Fintech_Payment_information_tLUn_cjbv": "再想想",
  "Fintech_Payment_information_pHvH_OrLr": "根据法律要求，当发生意外时，您账户里的资金会按比例分配给受益人，请您谨慎填写。",
  "Fintech_Payment_information_opfz_BtoE": "邮编",
  "Fintech_Payment_information_EixC_MnqL": "账户ID",
  "Fintech_Payment_modification_ewfK_RdNL": "我的税务信息",
  "Fintech_Payment_AF_BCXN_zpQI": "所有",
  "Fintech_Payment_out_nRbM_mVvJ": "系统繁忙，请重试（{{cs_code}}）",
  "Fintech_Payment_KYC_XwnO_pauL": "当前邮编无效，请检查",
  "Fintech_Payment_Bankstatement_dqvf_vpkB": "操作",
  "Fleet_Resdesign_Data_loading_pcxE": "数据加载中",
  "Fintech_Payment_KYC_xqow_swLI": "无，跳过",
  "Fintech_Payment_Bankstatement_Seea_rKSe": "电话：{{Sofipo_telephone_number}}",
  "Fintech_Payment_website_YdzR_rNSY": "4步",
  "Fintech_Payment_modification_JYgu_ThhR": "系统版本过低，拒绝访问文件",
  "Fintech_Payment_KYC_KfPp_SnbQ": "如有问题，请联系客服处理：{{sofipo_csphone}}",
  "Fintech_Payment_Bankstatement_RisF_kGmY": "重要提示",
  "Fintech_Payment_KYC_wsSR_nQPv": "继续",
  "Fintech_Payment_out_prmp_xxVR": "收款人",
  "Fintech_Payment_KYC_MKmB_EkXV": "姓名",
  "Fintech_Payment_page_JPfV_zUWX": "哎呀，出错了",
  "Fintech_Payment_page_IYZc_JGJx": "请稍后重试或检查你的网络连接。如果仍然失败，请更换网络试试",
  "Fintech_Payment_page_IICG_TMSY": "通过系统分享邀请",
  "Fintech_Payment_information_Wjkj_hnPe": "街道",
  "Fintech_Payment_AF_uUvN_EGHm": "转账",
  "Fintech_Payment_page_CTsY_Dmrb": "我知道了",
  "Fintech_Payment_Bankstatement_wIxX_zPcR": "SPEI入金",
  "Fintech_Payment_limits_NaMf_JcsO": "刷新",
  "Fintech_Payment_Ahorro_dGgq_KZal": "重试",
  "Fintech_Payment_KYC_ENgG_RwQm": "有，继续填写",
  "Fintech_Payment_KYC_cBre_kkHZ": "您在{{occupied_retry_limit_hour}}小时内还剩1次重试机会，如再次输入错误，您可在{{occupied_retry_limit_hour}}小时后重试",
  "Fintech_Payment_page_sVWx_pnmL": "抱歉，你需要更新App到最新版本才能参与该活动。你也可以点击按钮了解{{didi_cuenta}}的更多活动。",
  "Fintech_Payment_out_MSnG_HwNe": "近期使用",
  "Fintech_Payment_out_GPAk_BVgb": "收款人",
  "Fintech_Payment_out_xqdz_fptx": "收款银行",
  "Fintech_Payment_helpcenter_kDlf_knuA": "{{brand_name}}帮助中心",
  "Fintech_Payment_Bankstatement_NBuR_UWJy": "收款方",
  "Fintech_Payment_Bankstatement_gHRD_NonM": "日平均余额",
  "Fintech_Payment_AF_iGoO_ypBi": "历史",
  "Fintech_Payment_modification_MdCM_dIqR": "文件格式错误",
  "Fintech_Payment_out_KRxS_XwKV": "去转账",
  "Fintech_Payment_AF_HwIo_FrYZ": "交易详情",
  "Fintech_Payment_compliance_Wyil_Zaqm": "保存收款人",
  "Fintech_Payment_compliance_kmji_yDPA": "保存收款人方便下次使用。",
  "Fintech_Payment_modification_krBM_IhkQ": "税务制度",
  "Fintech_Payment_information_SqPO_GduE": "个人中心",
  "Fintech_Payment_Optimization_tHGy_IYgN": "释放立即刷新",
  "Fintech_Payment_information_gien_BDnw": "受益人年龄需大于18周岁，小于85周岁",
  "Fintech_Payment_information_gzjP_DzDg": "受益人第二姓",
  "Fintech_Payment_limits_fmtm_NrdR": "OK",
  "Fintech_Payment_page_oDTv_Emyj": "不用了",
  "Fintech_Payment_Bankstatement_UpAF_OORe": "如果你对交易或其他信息有任何疑问，请联系我们的客服：{{CS_phone_number}}。你最多有90天的时间来提出任何澄清。",
  "Fintech_Payment_interest_BAfU_KYJw": "收益",
  "Fintech_Payment_information_cBgX_dXkO": "外部门牌号",
  "Fintech_Payment_out_sDmk_VATG": "（可选）",
  "Fintech_Payment_information_rYgt_cISP": "比例不可低于1%",
  "Fintech_Payment_interest_kGNQ_pVHx": "扣税金额",
  "Fintech_Payment_AF_QpIB_AERj": "2月",
  "Fintech_Payment_information_FDpV_ODgJ": "受益人第一姓",
  "Fintech_Payment_website_mavi_GbHP": "请输入邮箱",
  "Fintech_Payment_out_YhXy_rMmr": "使用以下信息来为{{brand_name}}余额充值",
  "Fintech_Payment_Bankstatement_jnum_icwT": "交易ID",
  "Fintech_Payment_Optimization_bymF_byCA": "交易结果",
  "Fintech_Payment_Homepage_lqUj_UKQg": "存入",
  "Fintech_Payment_deposit_qpup_NGOx": "CLABE",
  "Fintech_Payment_limits_EZti_bVFY": "你输入的金额不能为0。",
  "Fintech_Payment_KYC_DtGd_zTDS": "电子邮件",
  "Fintech_Payment_website_LWta_xkpm": "提交成功",
  "Fintech_Payment_information_AfvT_aEBB": "街区",
  "Fintech_Payment_Bankstatement_hOdy_FqBn": "余额",
  "Fintech_Payment_page_xOpT_iwcr": "你真的要错过邀请朋友加入{{DiDi_Cuenta}}机会吗？可以帮他们赚更多收益哦～",
  "Fintech_Payment_Bankstatement_kxBr_CoBu": "服务异常",
  "Fintech_Payment_website_PQAp_tKWp": "我们期待你早日到来！",
  "Fintech_Payment_interest_kSNl_nSdf": "收益模拟",
  "Fintech_Payment_AF_rfVr_WNwz": "8月",
  "Fintech_Payment_modification_eWBN_NQGs": "当我们完成核实，会通过邮件通知你结果。",
  "Fintech_Payment_KYC_fIJh_dXsj": "性别",
  "Fintech_Payment_interest_bjTF_glLz": "此金额为扣税后金额",
  "Fintech_Payment_deposit_knBn_gUEK": "你的资金受到保护基金的保障。",
  "Fintech_Payment_AF_fXUE_ZcYk": "历史",
  "Fintech_Payment_KYC_TYRL_UHBj": "手机号格式错误",
  "Fintech_Payment_deposit_MUBS_fNDh": "目的地银行",
  "Fintech_Payment_modification_Gyta_xHeT": "文件过大（超出最大限制）",
  "Fintech_Payment_information_gvGr_wpac": "没有多余的比例分配给新的受益人了，如需继续添加，请重新设置比例",
  "Fintech_Payment_modification_itwI_hUTZ": "文件读取失败",
  "Fintech_Payment_modification_RSHt_ndfh": "第二姓",
  "Fintech_Payment_KYC_Qlzk_XvJj": "抱歉，您已达到了每{{occupied_retry_limit_hour}}小时最多重试{{limit_times}}次的限制。",
  "Fintech_Payment_information_awgy_TfAc": "市区",
  "Fintech_Payment_deposit_CZPp_ckng": "CLABE",
  "Fintech_Payment_Optimization_BIAB_lwdr": "交易详情",
  "Fintech_Payment_limits_nTTb_OIBh": "数字无效。请重试。",
  "Fintech_Payment_KYC_AnWj_fktR": "为保您的账户安全，请填写您的联系信息",
  "Fintech_Payment_Bankstatement_cwrx_hynB": "预览",
  "Fintech_Payment_deposit_tUEw_gdkO": "你的存款通常在几分钟到一小时内显示到账，但有时可能延迟约24小时。一旦我们收到款项，‌将立即通过电子邮件通知你。",
  "Fintech_Payment_page_otEb_WJBX": "你要放弃帮朋友赚更多收益的机会吗？",
  "Fintech_Payment_out_gwMW_faQG": "复制",
  "Fintech_Payment_KYC_eWvY_kNRU": "姓名过长，最多100字符",
  "Fintech_Payment_Ahorro_mFQz_mpkb": "网络不畅",
  "Fintech_Payment_out_vXtA_BWXM": "保存你的{{brand_name}}CLABE并输入你想要充值的金额",
  "Fintech_Payment_AF_yLfN_dGSL": "充值",
  "Fintech_Payment_KYC_bfgH_PnwM": "好的",
  "Fintech_Payment_Bankstatement_Aasp_ARbC": "第一姓：{{client_father_surname}}",
  "Fintech_Payment_deposit_pGCE_WTug": "你的资金受到保护基金的保障。",
  "Fintech_Payment_Bankstatement_FAXa_uhmr": "转账手续费",
  "Fintech_Payment_Bankstatement_HnlA_MYGF": "地址：{{client_address}}",
  "Fintech_Payment_AF_gZgm_wjTw": "确认",
  "Fintech_Payment_out_YguV_vhYc": "完成",
  "Fintech_Payment_out_JvbB_ULMX": "银行名称",
  "Fintech_Payment_compliance_myyv_UNBP": "保存成功",
  "Fintech_Payment_Bankstatement_ylvG_Dywq": "费率",
  "Fintech_Payment_AF_KMcq_mVba": "7月",
  "Fintech_Payment_simulado_DiNq_bAix": "时长(天)",
  "Fintech_Payment_page_vslk_brnN": "查看我的邀请",
  "Fintech_Payment_page_WqZl_sRoM": "展示更多",
  "Fintech_Payment_information_TrDL_iykt": "保留",
  "Fintech_Payment_information_RBeT_ASwx": "姓名",
  "Fintech_Payment_optimization_lSek_omte": "全部",
  "Fintech_Payment_KYC_qrff_Jjlj": "街道和门牌号（内部和外部）",
  "Fintech_Payment_out_tpAm_Gebw": "请勿超过最高可转账金额{{amount}}",
  "Fintech_Payment_KYC_YHhc_UqVg": "请确认您的CURP是否输入正确，如有问题请联系客服处理：{{sofipo_csphone}}",
  "Fintech_Payment_website_oDvN_dDjs": "当你可使用{{brand_name}}服务时，我们会通过短信和邮件通知你",
  "Fintech_Payment_modification_AxYk_gqDO": "第一姓",
  "Fintech_Payment_KYC_AXpD_yHSr": "请确认您的手机号是否输入正确，如有问题请联系客服处理：{{sofipo_csphone}}",
  "Fintech_Payment_Bankstatement_oURi_nwyv": "支付",
  "Fintech_Payment_information_HyID_LHyK": "添加受益人",
  "Fintech_Payment_compliance_XDas_earR": "网络异常，请重试",
  "Fintech_Payment_page_DKvP_LGHp": "重试",
  "Fintech_Payment_Bankstatement_UsnV_GrXD": "客户ID：{{client_ID}}",
  "Fintech_Payment_AF_TplY_FLqG": "{{brand_name}}余额",
  "Fintech_Payment_out_VHkP_Imvq": "转账",
  "GRider_part2_Cancel_pNIR": "取消",
  "Fintech_Payment_KYC_VsBG_JucB": "第二姓",
  "Fintech_Payment_Ahorro_DtZv_ntHp": "网络不稳定，请稍后重试",
  "Fintech_Payment_information_EmHe_dUby": "添加受益人，最多可添加{{beneficiary_max}}位。",
  "Fintech_Payment_website_jKqP_Gqla": "如需继续，请同意{{{Notice_name}}}",
  "Fintech_Payment_KYC_qTby_Fnnc": "CURP格式错误，请重新填写",
  "Fintech_Credit_adjustment_TzfM_zgIR": "退出登录",
  "Fintech_Payment_page_xxda_gEqM": "下载{{Dinero}}",
  "Fintech_Payment_AF_iknn_PlqT": "登录",
  "Fintech_Payment_KYC_qXAw_pVOQ": "未填写第二姓，请确认您是否有第二姓",
  "Fintech_Payment_KYC_ysqu_aYrF": "为更好的为您提供服务，请同意并签署协议",
  "Fintech_Payment_page_eqrN_OTpK": "请输入手机号",
  "Fintech_Payment_information_hgYQ_tQxl": "电子邮箱",
  "Fintech_Payment_information_TBSl_StvR": "复制",
  "Fintech_Payment_Bankstatement_vlax_qixg": "下一页继续",
  "Fintech_Payment_AF_OEFN_ytYe": "3月",
  "Fintech_Payment_Optimization_oOuc_Cfsk": "收入",
  "Fintech_Payment_modification_eQwF_xWxX": "网络错误，请稍后重试",
  "Fintech_Payment_interest_urQk_fzCP": "存入金额",
  "Fintech_Payment_deposit_YUps_erzK": "存款完成",
  "Fintech_Payment_information_DVNj_AgnB": "确定",
  "Fintech_Payment_out_yZsY_EvIm": "18位数字",
  "Fintech_Payment_information_tTZZ_hLLV": "在这里设置比例",
  "Fintech_Payment_modification_EGDg_LnPx": "RFC",
  "Fintech_Payment_Bankstatement_ODrW_rHOu": "期末余额",
  "Fintech_Payment_Bankstatement_ePTe_dXpF": "账户ID：{{account_ID}}",
  "Fintech_Payment_KYC_lbWE_gASK": "第一姓",
  "Fintech_Payment_Bankstatement_aPih_wMNV": "收入",
  "Fintech_Payment_2_mJns_qxor": "下载app",
  "Fintech_Payment_KYC_RgjA_vYVl": "出生日期",
  "Fintech_Payment_Bankstatement_jFfT_dnLZ": "周期：{{bank_statement_period}}",
  "Fintech_Payment_AF_pJXV_lZvb": "4月",
  "Fintech_Credit_2_uFFp_xzbd": "邮政编码",
  "Fintech_Payment_website_lqdT_FJGg": "请输入姓名",
  "Fintech_Payment_information_KUsQ_cYXy": "复制成功",
  "Fintech_Payment_AF_WOJT_DqtE": "存款",
  "Fintech_Payment_out_UstT_nhmd": "复制你的{{brand_name}}{CLABE}到银行app或在银行网点提供给银行",
  "Fintech_Payment_interest_xSFa_WJEH": "时长（月）",
  "Fintech_Payment_KYC_hCgl_mGgu": "验证码已发送至{{user_phone}}",
  "Fintech_Payment_Bankstatement_JpFH_XKLj": "银行对账单",
  "Fintech_Payment_information_pApu_zbLJ": "退出",
  "Fintech_Payment_deposit_NBVB_Eeln": "收款人",
  "Fintech_Payment_out_eONV_CHHd": "已保存的收款人",
  "Fintech_Payment_information_ziNL_LQwo": "如退出此页面，已填写的信息不会被保存，确定要退出吗？",
  "Fintech_Payment_compliance_VAAJ_cYfZ": "保存失败，请重试",
  "Fintech_Payment_information_sROF_duGS": "账户ID是您账户的唯一标识，您可用此来联系客服查询您的账户信息，索要对账单等",
  "Fintech_Payment_change_lUYQ_yEus": "你仅需三分钟即可开户",
  "Fintech_Payment_out_KmNP_EINS": "请输入有效的18位CLABE",
  "Fintech_Payment_Optimization_dMIL_yaHK": "下拉刷新",
  "Fintech_Payment_Bankstatement_EluZ_PzvO": "手续费明细",
  "Fintech_Payment_homepage_oPWn_PLKR": "我知道了",
  "Fintech_Payment_KYC_Wocg_BFmh": "手机号码（将用于接收验证码）",
  "Fintech_Payment_Bankstatement_WFuw_mHmR": "银行账单核验失败",
  "Fintech_Payment_website_lwrz_wDUy": "请输入手机号",
  "Fintech_Payment_KYC_xGBA_EheK": "重新发送",
  "Fintech_Payment_KYC_MsXR_sJQR": "出生地点",
  "Fintech_Payment_Bankstatement_GvAh_icxd": "天数：{{days_of_period}}",
  "Fintech_Payment_Optimization_OxQL_YjpS": "总金额",
  "Fintech_Payment_information_JKkT_xZkL": "比例已达到100%",
  "Fintech_Payment_page_rBAg_wXlw": "未登录",
  "Fintech_Payment_information_QXCX_lMaj": "出生日期",
  "Fintech_Payment_Bankstatement_eert_SSpI": "数额",
  "Fintech_Payment_AF_BUgR_eCUa": "11月",
  "Fintech_Payment_information_VbVV_XOSn": "删除",
  "Fintech_Payment_information_ViRA_fPZX": "为您的受益人设置比例，所有受益人的比例总和需等于100%。",
  "Fintech_Payment_website_eJnt_dWIz": "仅需2分钟即可开通{{brand_name}}，开通过程中需进行身份验证。",
  "Fintech_Payment_information_bqmo_InXV": "受益人信息",
  "Fintech_Payment_deposit_fTwc_mSVi": "打开你的银行App或网站并找到转账功能。复制并粘贴CLABE。",
  "Fintech_Payment_Bankstatement_ZjXW_HvDF": "种类",
  "Fintech_Payment_AF_kbUg_IwcT": "你好，欢迎回来",
  "Fintech_Payment_Optimization_onZm_HWQv": "我知道了",
  "Fintech_Payment_information_QZfY_vkgM": "个人资料",
  "Fintech_Payment_modification_DmzX_NThI": "这是你最新的税务信息。请确保它与SAT的信息一致。若不匹配，需要再次上传。",
  "Fintech_Payment_2_WgYE_UdrG": "风险核验失败",
  "Fintech_Payment_2_nhbq_BHft": "你可以保存图片，并邀请你的朋友扫描上方的二维码来参与活动。",
  "Fintech_Payment_page_VCEr_tmwW": "选择分享方式",
  "Fintech_Payment_out_EOvE_qAwT": "分享信息",
  "Fintech_Payment_information_kxof_vUbv": "州",
  "Fintech_Payment_page_YKwh_MTEd": "新版本升级",
  "Fintech_Payment_information_kcbW_iRYZ": "国家",
  "Wallet_App_V2_Please_confirm_Pdiy": "请确认网络设置，稍后重试支付。",
  "Fintech_Payment_out_pxGY_wlQW": "输入转账金额",
  "Fintech_Payment_Bankstatement_nQyR_PjUQ": "货币",
  "Fintech_Payment_out_mTCa_SdSS": "转账金额",
  "Fintech_Payment_information_xbPB_LJNs": "以上信息保存后将具有法律效力，是否继续保存？",
  "Fintech_Payment_KYC_xTXj_JDgc": "该手机号已被注册",
  "Fintech_Payment_AF_HEfh_nZDt": "未找到交易",
  "Fintech_Payment_modification_dczQ_FbPu": "你的税务信息已经更新成功",
  "Fintech_Payment_Bankstatement_PCJo_LTwh": "提现手续费",
  "Fintech_Payment_Bankstatement_qAyc_YplQ": "数据加载失败，请稍后重试",
  "Fintech_Payment_KYC_Aufz_tEJN": "我知道了",
  "Fintech_Payment_page_CsDR_GUBk": "重试",
  "Fintech_Payment_Optimization_SToL_eqvn": "筛选",
  "Fintech_Payment_modification_GLNo_TyMd": "名字",
  "Fintech_Payment_Bankstatement_QESf_XgpX": "第二姓：{{client_mother_surname}}",
  "Fintech_Payment_Homepage_GLan_EOfn": "你的资金受保护基金保障",
  "Fintech_Payment_out_VYYS_orQb": "收款人名字",
  "Fintech_Payment_page_gsRP_Xfxf": "提醒",
  "Fintech_Payment_information_hHXE_gOtp": "比例总和已超出{{exceed_percent}}，请重新设置",
  "Fintech_Payment_Bankstatement_qwYv_fnps": "转账",
  "Fintech_Payment_KYC_BHGw_Oqap": "CURP",
  "Fintech_Payment_out_lghW_FUcU": "如何充值？",
  "Fintech_Payment_AF_tkBP_jobH": "10月",
  "Fintech_Payment_Bankstatement_FiNb_nubW": "第{{page_number}}页，共{{number_of_pages}}页",
  "Fintech_Payment_out_QYBO_jRKW": "转账附言",
  "Fintech_Payment_interest_BbNK_VACp": "时长（月）",
  "Fintech_Payment_Bankstatement_tWjm_XCjp": "总额",
  "Fintech_Payment_Bankstatement_lSib_SWyR": "银行账单流水不存在",
  "Fintech_Payment_website_zuqt_NNQR": "请输入10位数字",
  "Fintech_Payment_helpcenter_jjmJ_itJL": "答案",
  "Fintech_Payment_Page_jeVI_qDzp": "加载中..."
}